import { enqueueSnackbar } from "notistack";
import { CAP, CashFlowClassification, CashFlowMapping, GTBClassification, ServerAPIResponse, SocialAccountMapping } from "../helpers/interfaces";
import { callServerAPI, showBackDrop } from "../helpers/utils";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

const MySwal = withReactContent(Swal);

//CashFlowClassification
export const getAllCashFlowClassification = async () => {
    return await new Promise<CashFlowClassification[]>(async (resolve, reject) => {
        MySwal.fire(showBackDrop("Loading Cash Flow Classification"));
        callServerAPI<ServerAPIResponse<CashFlowClassification[]>>('GET', `/api/v1/CashFlowClassification?PageSize=100&OrderBy=ASCENDING&api-version=1`, null, true)
            .then(response => {
                MySwal.close()
                resolve(response.data.data)
            })
    })
}
export async function createCashFlowClassification(name: string) {
    const cfcData = { name: name }
    return await new Promise<CashFlowClassification>(async (resolve, reject) => {
        MySwal.fire(showBackDrop("Creating new Cash Flow Classification"));
        callServerAPI<ServerAPIResponse<CashFlowClassification>>('POST', `/api/v1/CashFlowClassification?api-version=1`, cfcData, true)
            .then(response => {
                MySwal.close()
                enqueueSnackbar("Cash Flow Classification Created", { variant: 'success' });
                resolve(response.data.data)
            })
    })
}

export async function updateCashFlowClassification(id: string, name: string) {
    const cfcData = { name: name }
    return await new Promise<CashFlowClassification>(async (resolve, reject) => {
        MySwal.fire(showBackDrop("Updating Cash Flow Classification"));
        callServerAPI<ServerAPIResponse<CashFlowClassification>>('PUT', `/api/v1/CashFlowClassification?id=${id}&api-version=1`, cfcData, true)
            .then(response => {
                MySwal.close()
                enqueueSnackbar("Cash Flow Classification Updated", { variant: 'success' });
                resolve(response.data.data)
            })
    })
}

export async function deleteCashFlowClassification(id: string) {
    return await new Promise<void>(async (resolve, reject) => {
        MySwal.fire(showBackDrop("Deleting Cash Flow Classification"));
        await callServerAPI<any>('DELETE', `/api/v1/CashFlowClassification?id=${id}&api-version=1`, null, true)
            .then(response => {
                MySwal.close()
                enqueueSnackbar("Cash Flow Classification Deleted", { variant: 'success' });
                resolve()
            })
    })
}

//CashFlowMapping
export const getAllCashFlowMappings = async () => {
    return await new Promise<CashFlowMapping[]>(async (resolve, reject) => {
        MySwal.fire(showBackDrop("Loading Cash Flow Mapping"));
        callServerAPI<ServerAPIResponse<CashFlowMapping[]>>('GET', `/api/v1/CashFlowMapping?PageSize=100&OrderBy=ASCENDING&api-version=1`, null, true)
            .then(response => {
                MySwal.close()
                resolve(response.data.data)
            })
    })
}
export async function createCashFlowMapping(name: string) {
    const cfmData = { name: name }
    return await new Promise<CashFlowMapping>(async (resolve, reject) => {
        MySwal.fire(showBackDrop("Creating new Cash Flow Mapping"));
        callServerAPI<ServerAPIResponse<CashFlowMapping>>('POST', `/api/v1/CashFlowMapping?api-version=1`, cfmData, true)
            .then(response => {
                MySwal.close()
                enqueueSnackbar("Cash Flow Mapping Created", { variant: 'success' });
                resolve(response.data.data)
            })
    })
}

export async function updateCashFlowMapping(id: string, name: string) {
    const cfmData = { name: name }
    return await new Promise<CashFlowMapping>(async (resolve, reject) => {
        MySwal.fire(showBackDrop("Updating Cash Flow Mapping"));
        callServerAPI<ServerAPIResponse<CashFlowMapping>>('PUT', `/api/v1/CashFlowMapping?id=${id}&api-version=1`, cfmData, true)
            .then(response => {
                MySwal.close()
                enqueueSnackbar("Cash Flow Mapping Updated", { variant: 'success' });
                resolve(response.data.data)
            })
    })
}

export async function deleteCashFlowMapping(id: string) {
    return await new Promise<void>(async (resolve, reject) => {
        MySwal.fire(showBackDrop("Deleting Cash Flow Mapping"));
        await callServerAPI<any>('DELETE', `/api/v1/CashFlowMapping?id=${id}&api-version=1`, null, true)
            .then(response => {
                MySwal.close()
                enqueueSnackbar("Cash Flow Mapping Deleted", { variant: 'success' });
                resolve()
            })
    })
}

//GTBClassification
export const getAllGTBClassification = async () => {
    return await new Promise<GTBClassification[]>(async (resolve, reject) => {
        MySwal.fire(showBackDrop("Loading Classification Mapping Key "));
        callServerAPI<ServerAPIResponse<GTBClassification[]>>('GET', `/api/v1/GTBClassification?PageSize=100&OrderBy=ASCENDING&api-version=1`, null, true)
            .then(response => {
                MySwal.close()
                resolve(response.data.data)
            })
    })
}
export async function createGTBClassification(name: string) {
    const gtbClassificationData = { name: name }
    return await new Promise<GTBClassification>(async (resolve, reject) => {
        MySwal.fire(showBackDrop("Creating new Classification Mapping Key"));
        callServerAPI<ServerAPIResponse<GTBClassification>>('POST', `/api/v1/GTBClassification?api-version=1`, gtbClassificationData, true)
            .then(response => {
                MySwal.close()
                enqueueSnackbar("Classification Mapping Key Created", { variant: 'success' });
                resolve(response.data.data)
            })
    })
}

export async function updateGTBClassification(id: string, name: string) {
    const gtbClassificationData = { name: name }
    return await new Promise<GTBClassification>(async (resolve, reject) => {
        MySwal.fire(showBackDrop("Updating Classification Mapping Key"));
        callServerAPI<ServerAPIResponse<GTBClassification>>('PUT', `/api/v1/GTBClassification?id=${id}&api-version=1`, gtbClassificationData, true)
            .then(response => {
                MySwal.close()
                enqueueSnackbar("Classification Mapping Key Updated", { variant: 'success' });
                resolve(response.data.data)
            })
    })
}

export async function deleteGTBClassification(id: string) {
    return await new Promise<void>(async (resolve, reject) => {
        MySwal.fire(showBackDrop("Deleting Classification Mapping Key"));
        await callServerAPI<any>('DELETE', `/api/v1/GTBClassification?id=${id}&api-version=1`, null, true)
            .then(response => {
                MySwal.close()
                enqueueSnackbar("Classification Mapping Key Deleted", { variant: 'success' });
                resolve()
            })
    })
}

//SocialAccountMapping
export const getAllSocialAccountMapping = async () => {
    return await new Promise<SocialAccountMapping[]>(async (resolve, reject) => {
        MySwal.fire(showBackDrop("Loading Social Account Mapping Key "));
        callServerAPI<ServerAPIResponse<SocialAccountMapping[]>>('GET', `/api/v1/SocialAccountMapping?PageSize=100&OrderBy=ASCENDING&api-version=1`, null, true)
            .then(response => {
                MySwal.close()
                resolve(response.data.data)
            })
    })
}
export async function createSocialAccountMapping(name: string) {
    const recData = { name: name }
    return await new Promise<SocialAccountMapping>(async (resolve, reject) => {
        MySwal.fire(showBackDrop("Creating new Social Account Mapping Key"));
        callServerAPI<ServerAPIResponse<SocialAccountMapping>>('POST', `/api/v1/SocialAccountMapping?api-version=1`, recData, true)
            .then(response => {
                MySwal.close()
                enqueueSnackbar("Social Account Mapping Key Created", { variant: 'success' });
                resolve(response.data.data)
            })
    })
}

export async function updateSocialAccountMapping(id: string, name: string) {
    const recData = { name: name }
    return await new Promise<SocialAccountMapping>(async (resolve, reject) => {
        MySwal.fire(showBackDrop("Updating Social Account Mapping Key"));
        callServerAPI<ServerAPIResponse<SocialAccountMapping>>('PUT', `/api/v1/SocialAccountMapping?id=${id}&api-version=1`, recData, true)
            .then(response => {
                MySwal.close()
                enqueueSnackbar("Social Account Mapping Key Updated", { variant: 'success' });
                resolve(response.data.data)
            })
    })
}

export async function deleteSocialAccountMapping(id: string) {
    return await new Promise<void>(async (resolve, reject) => {
        MySwal.fire(showBackDrop("Deleting Social Account Mapping Key"));
        await callServerAPI<any>('DELETE', `/api/v1/SocialAccountMapping?id=${id}&api-version=1`, null, true)
            .then(response => {
                MySwal.close()
                enqueueSnackbar("Social Account Mapping Key Deleted", { variant: 'success' });
                resolve()
            })
    })
}

//CAP
export const getAllCAP = async () => {
    return await new Promise<CAP[]>(async (resolve, reject) => {
        MySwal.fire(showBackDrop("Loading CAP Mapping Key "));
        callServerAPI<ServerAPIResponse<CAP[]>>('GET', `/api/v1/CAP?PageSize=100&OrderBy=ASCENDING&api-version=1`, null, true)
            .then(response => {
                MySwal.close()
                resolve(response.data.data)
            })
    })
}
export async function createCAP(code: string, description: string) {
    const capData = {
        code: code,
        description: description
    }
    return await new Promise<CAP>(async (resolve, reject) => {
        MySwal.fire(showBackDrop("Creating new CAP Mapping Key"));
        callServerAPI<ServerAPIResponse<CAP>>('POST', `/api/v1/CAP?api-version=1`, capData, true)
            .then(response => {
                MySwal.close()
                enqueueSnackbar("CAP Mapping Key Created", { variant: 'success' });
                resolve(response.data.data)
            })
    })
}

export async function updateCAP(id: string, code: string, description: string) {
 const capData = {
        code: code,
        description: description
    }
    return await new Promise<CAP>(async (resolve, reject) => {
        MySwal.fire(showBackDrop("Updating CAP Mapping Key"));
        callServerAPI<ServerAPIResponse<CAP>>('PUT', `/api/v1/CAP?id=${id}&api-version=1`, capData, true)
            .then(response => {
                MySwal.close()
                enqueueSnackbar("CAP Mapping Key Updated", { variant: 'success' });
                resolve(response.data.data)
            })
    })
}

export async function deleteCAP(id: string) {
    return await new Promise<void>(async (resolve, reject) => {
        MySwal.fire(showBackDrop("Deleting CAP Mapping Key"));
        await callServerAPI<any>('DELETE', `/api/v1/CAP?id=${id}&api-version=1`, null, true)
            .then(response => {
                MySwal.close()
                enqueueSnackbar("CAP Mapping Key Deleted", { variant: 'success' });
                resolve()
            })
    })
}
